// Ends the server session (clears the login cookie) and returns to the login page.
// The full page reload also resets the app's isAuthenticated state.
export async function logout() {
    try {
        await fetch('/api/login/logout', { method: 'POST' });
    } catch (err) {
        console.error('Logout request failed:', err);
    }
    sessionStorage.clear();
    window.location.replace('/LoginPage');
}
